import React from 'react';
import PropTypes from 'prop-types';
import 'react-tabs/style/react-tabs.css';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PointList from '../settings/PointList';
import BondSetting from './BondSetting';
import CollectionFeeList from '../settings/CollectionFeeList';
import PrincipalList from '../settings/PrincipalList';



const BondTab = ({ data }) => {
  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }


  let leg1 = data.bond.legs[0];

  return (
    <div>
      <div className="grid">              
        <div className="col s4of12">
            <BondSetting data={data.bond}/>
        </div>
        <div className="col s4of12">          

        </div>      
        <div className="col s4of12">
          {leg1.bondType.bondTypeID === 3 && <PrincipalList data={data}/>}        
        </div>
      </div>
      <div className="grid">              
        <div className="col s4of12">
          {/* <PointList title="Samningsvextir" isPercent={false} hasExtra={false} points={data.vatTable.points}  calculateToDate={data.calculateTo} oldestDueDate={data.oldestDueDate}/> */}
        contractInterests
        </div>
        <div className="col s4of12">
        overwritePayments
        </div>
        <div className="col s4of12">
        EqualizationTable
        OverwritePayments
        </div>
        <div className="col s4of12">          
        SlipCostTable
        IndexTable
        </div>
      </div> 
      <div className="grid">
        <div className="col s4of12">
          {leg1.slipCostTable && <PointList title="Greiðsluseðlagjald" isPercent={false} hasExtra={false} points={leg1.slipCostTable.points}  calculateToDate={data.calculateTo} oldestDueDate={data.oldestDueDate}/>}
        </div>
        <div className="col s4of12">
          {leg1.slipCostTable && <PointList title="Milliinnheimtugjald" isPercent={false} hasExtra={false} points={leg1.slipCostTable.points}  calculateToDate={data.calculateTo} oldestDueDate={data.oldestDueDate}/>}          
        </div>
      </div>     
    </div>
  );
};

BondTab.propTypes = {
  data: PropTypes.object,
};

export default BondTab;
